import { Suspense, useEffect, useRef, useState } from "react";

// Fired by the page once every below-the-fold chunk is warm, so all sections mount at once (no pop-in while scrolling).
export const SECTIONS_READY = "affinity:sections-ready";

const TONES = { dark: "var(--navy)", cream: "var(--cream)", sand: "var(--sand)" };

// Mounts (and code-splits) a below-the-fold section once it is within ~2 viewports; placeholder keeps the section's theme colour.
export const LazySection = ({ children, minHeight = 560, tone = "dark", testId }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(() => typeof window !== "undefined" && (!!window.location.hash || !("IntersectionObserver" in window)));

  useEffect(() => {
    if (show || !ref.current) return undefined;
    const reveal = () => setShow(true);
    const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { reveal(); io.disconnect(); } }, { rootMargin: "1600px 0px" });
    io.observe(ref.current);
    window.addEventListener(SECTIONS_READY, reveal, { once: true });
    return () => { io.disconnect(); window.removeEventListener(SECTIONS_READY, reveal); };
  }, [show]);

  const box = { minHeight, background: TONES[tone] || TONES.dark };
  if (!show) return <div ref={ref} style={box} aria-hidden data-testid={testId ? `${testId}-placeholder` : undefined} />;
  return <Suspense fallback={<div style={box} aria-hidden />}>{children}</Suspense>;
};
